import { IConnection } from "../models/connection"
import { IWorkspaceCustomField } from "../models/workspace"

//Enums
export enum ActionType {
    SET_FILTER_HIDDEN_CONNECTIONS = "SET_FILTER_HIDDEN_CONNECTIONS",
    RESET_STORE = "RESET_STORE",
    SET_CONNECTIONS_FILTER = "SET_CONNECTIONS_FILTER",
    SET_CAMPAIGN_CONNECTIONS_FILTER = "SET_CAMPAIGN_CONNECTIONS_FILTER",
    REPLACE_CAMPAIGN_CONNECTIONS_FILTER = "REPLACE_CAMPAIGN_CONNECTIONS_FILTER",
    SET_CONNECTIONS_FILTER_SCOPE = "SET_CONNECTIONS_FILTER_SCOPE",
    SET_CONNECTIONS_PARAMETERS = "SET_CONNECTIONS_PARAMETERS",
    SET_CONNECTIONS = "SET_CONNECTIONS",
    SET_FITLERING_TAGS = "SET_FITLERING_TAGS",
    SET_MULTIPLE_CONDITIONS_FILTERS = "SET_MULTIPLE_CONDITIONS_FILTERS",
    SET_CONNECTIONS_FILTER_OPTIONS = "SET_CONNECTIONS_FILTER_OPTIONS",
    RESET_CONNECTIONS_PAGINATION = "RESET_CONNECTIONS_PAGINATION",
    SET_SCHEDULED_REMOVAL_PARAMETERS = "SET_SCHEDULED_REMOVAL_PARAMETERS",
    SET_SELECTED_CONNECTIONS_IDS = "SET_SELECTED_CONNECTIONS_IDS",
    PATCH_CONNECTION = "PATCH_CONNECTION",
    SET_CUSTOM_FIELD_DEFINITIONS = "SET_CUSTOM_FIELD_DEFINITIONS",
    SET_ENRICHING_CONNECTIONS = "SET_ENRICHING_CONNECTIONS",
}

//Interfaces


//States
export type TConnectionsState = {
    connections: IConnection[],
    connectionsFilter: TConnectionsFilterState,
    /** Filter used by the campaign LeadDelta Contacts search. Lives only in memory for this session. */
    campaignConnectionsFilter: TConnectionsFilterState,
    /** Which filter the shared filter widgets read and write. */
    connectionsFilterScope: 'contacts' | 'campaign',
    connectionsParameters: TConnectionsParametersState,
    connectionFilterOptions: any,
    scheduledRemovalParameters: TScheduledRemovalParametersState,
    selectedConnectionsIds: string[],
    customFieldDefinitions: IWorkspaceCustomField[],
    /** Enrichments initiated from the sidebar (single-field enrich again) */
    enrichingConnections: Array<{ connectionId: string; type: string }>,
}

export type TConnectionsFilterState = {
    // searchByName: string,
    // searchByCompany: string,
    // searchByHeadline: string,
    hiddenConnectionsValue: THiddenConnectionsState,
    tagCondition: string,
    selectedTags: string[],
    languageCondition: string,
    selectedLanguages: string[],
    usersMutualCondition: string,
    connectionIdsFilter?: string[],
    connectionIdsFilterMeta?: {
        source: 'ai-chat' | 'hubspot-export',
        title?: string
    }
}

export type TConnectionsParametersState = {
    page: number,
    pageSize: number,
    total: number
}

export type THiddenConnectionsState = {
    value: string,
    label: string,
}

export type TScheduledRemovalParametersState = {
    total?: number,
    count?: number,
    dailyCount?: number,
    dailyLimit?: number,
    inProgress?: boolean,
    lastRemovedAt?: string,
}

interface ISetConnectionsFilterAction {
    type: ActionType.SET_CONNECTIONS_FILTER
    payload: TConnectionsState['connectionsFilter']
}

interface ISetCampaignConnectionsFilterAction {
    type: ActionType.SET_CAMPAIGN_CONNECTIONS_FILTER
    payload: TConnectionsState['campaignConnectionsFilter']
}

interface IReplaceCampaignConnectionsFilterAction {
    type: ActionType.REPLACE_CAMPAIGN_CONNECTIONS_FILTER
    payload: TConnectionsState['campaignConnectionsFilter']
}

interface ISetConnectionsFilterScopeAction {
    type: ActionType.SET_CONNECTIONS_FILTER_SCOPE
    payload: TConnectionsState['connectionsFilterScope']
}

interface ISetConnectionsParametersAction {
    type: ActionType.SET_CONNECTIONS_PARAMETERS
    payload: TConnectionsState['connectionsParameters']
}

interface ISetConnectionsAction {
    type: ActionType.SET_CONNECTIONS
    payload: TConnectionsState['connections']
}

interface IResetStoreAction {
    type: ActionType.RESET_STORE
}

interface ISetConnectionsFilterOptionsAction {
    type: ActionType.SET_CONNECTIONS_FILTER_OPTIONS
    payload: TConnectionsState['connectionFilterOptions']
}

interface IResetConnectionsPaginationAction {
    type: ActionType.RESET_CONNECTIONS_PAGINATION;
}

interface ISetScheduledRemovalParametersAction {
    type: ActionType.SET_SCHEDULED_REMOVAL_PARAMETERS
    payload: TConnectionsState['scheduledRemovalParameters']
}

interface ISetSelectedConnectionsIdsAction {
    type: ActionType.SET_SELECTED_CONNECTIONS_IDS
    payload: TConnectionsState['selectedConnectionsIds']
}

/** Merge-patches a single connection by _id without touching the rest of the list. */
interface IPatchConnectionAction {
    type: ActionType.PATCH_CONNECTION
    payload: { id: string; patch: Partial<IConnection> }
}

interface ISetCustomFieldDefinitionsAction {
    type: ActionType.SET_CUSTOM_FIELD_DEFINITIONS
    payload: IWorkspaceCustomField[]
}

interface ISetEnrichingConnectionsAction {
    type: ActionType.SET_ENRICHING_CONNECTIONS
    payload: TConnectionsState['enrichingConnections']
}

export type TConnectionAction = ISetConnectionsFilterAction | ISetCampaignConnectionsFilterAction | IReplaceCampaignConnectionsFilterAction | ISetConnectionsFilterScopeAction | ISetConnectionsParametersAction | IResetStoreAction | ISetConnectionsAction | ISetConnectionsFilterOptionsAction | IResetConnectionsPaginationAction | ISetScheduledRemovalParametersAction | ISetSelectedConnectionsIdsAction | IPatchConnectionAction | ISetCustomFieldDefinitionsAction | ISetEnrichingConnectionsAction;